import { useTranslation } from "react-i18next";
import RightViewLayout from "../../components/RighViewLayout";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import {
  attributeList,
  createAttribute,
  deleteAttribute,
} from "../../services/ProductService";
import CustomInput from "../../components/CustomInput";
import { REACT_PRODUCT_LABEL } from "../../router/ReactEndPoints";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import CommonUtil from "../../util/CommonUtils";
import Delete from "../../assets/images/Delete Icon.svg";

export default function ProductLabel() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const [fields, setFields] = useState([]);
  const [check, setCheck] = useState(false);
  const [newFields, setNewFields] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [id, setId] = useState("");
  const roleName = localStorage.getItem("ROLE_NAME");
  const permission = localStorage.getItem("permission");
  let isAllowedCreate = true;
  let isAllowedDelete = true;
  useEffect(() => {
    localStorage.setItem("newFields", JSON.stringify(newFields));
  }, [newFields]);
  const loadData = () => {
    attributeList().then((res) => {
      if (res?.data?.data && res?.data?.code === "LVLI0000") {
        let list = res.data.data.filter((item) => {
          return !(
            item.dataLevel === "System Default" && item.name === "priceRule"
          );
        });
        setFields(list);
      }
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleClose = () => {
    setConfirm(false);
  };

  const handleAddField = () => {
    if (newFields.length === 0) {
      const newField = { label: "", type: "", name: "" };
      setNewFields([...newFields, newField]);
      setCheck(true);
    }

    if (newFields.length > 0) {
      const newCardIndex = newFields.length - 1;

      const newCardElement = document.getElementById(`card-${newCardIndex}`);

      if (newCardElement) {
        newCardElement.scrollIntoView({ behavior: "smooth", block: "end" });
      } else {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      }
    }
  };

  if (roleName === "ADMIN") {
    isAllowedCreate = permission && permission.includes("AddProductLabel");
    // isAllowedDelete = permission && permission.includes("DeleteProductLabel");
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    if (newFields[0].label) {
      newFields.forEach((field) => {
        // field.label = capitalizeFirst(field.label);
        // field.name = toCamelCase(field.label);

        field.label = field.label;
        field.name = field.label;
        createAttribute(newFields).then((res) => {
          if (res?.data?.data && res?.data?.code === "LVLI0008") {
            enqueueSnackbar(t("tips_product.added_product"), {
              variant: "success",
            });
            setNewFields([]);
            loadData();
            navigate(REACT_PRODUCT_LABEL);
          }
          if (res?.data?.code !== "LVLI0008") {
            enqueueSnackbar(t(res.data.message), { variant: "error" });
          }
        });
      });
    } else {
      enqueueSnackbar(t("tips_product.field_empty"), { variant: "error" });
    }
  };

  const handleCancel = () => {
    setNewFields([]);
    setCheck(false);
  };

  const handleActions = (action, data) => {
    if (action === "Delete") {
      setId(data);
      setConfirm(true);
      localStorage.removeItem("newFields");
    }
  };

  const handleDelete = (id) => {
    deleteAttribute(id).then((res) => {
      if (res?.data?.code === "LVLE0034") {
        enqueueSnackbar(t("tips_product.cannot_deleted"), { variant: "error" });
      }
      if (res?.data?.code === "EPTE0070") {
        enqueueSnackbar(t("tips_product.last_deleted"), {
          variant: "error",
        });
      }

      if (res?.data?.code === "LVLI0002") {
        enqueueSnackbar(t("tips_product.deleted_product"), {
          variant: "success",
        });

        loadData();
        navigate(REACT_PRODUCT_LABEL);
      }
      setConfirm(false);
    });
  };

  const handleFieldChange = (index, field, value) => {
    const { name, value: fieldValue } = value.target || value;
    const updatedFields = [...newFields];

    if (name === "options") {
      const optionsArray = fieldValue.split(",");
      field[name] = optionsArray;
    } else {
      field[name] = fieldValue;
    }

    updatedFields[index] = { ...field };
    setNewFields(updatedFields);
  };

  return (
    <RightViewLayout navigateBack={false} title={t("product.title")}>
      <Grid container columnSpacing={1}>
        <Grid container direction="row" xs={12}>
          {fields.map((field, index) => (
            <Grid item>
              <Card
                style={{
                  width: 380,
                  height: 70,
                  borderRadius: 10,
                  marginLeft: "20px",
                  marginTop: "20px",
                  position: "relative",
                  overflow: "hidden",
                }}
                elevation={0}
              >
                <CardContent
                  style={{
                    height: "100%",
                    paddingRight:
                      field?.dataLevel !== "System Default" ? 48 : 16,
                    overflow: "hidden",
                  }}
                >
                  <Grid
                    container
                    item
                    xs={12}
                    alignItems="center"
                    style={{ height: "100%" }}
                  >
                    <Grid item xs={12} style={{ minWidth: 0 }}>
                      <Typography
                        variant="h6"
                        title={field.label}
                        style={{
                          overflow: "hidden",
                          overflowWrap: "anywhere",
                          wordBreak: "break-word",
                          lineHeight: 1.2,
                        }}
                      >
                        {field.label}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
                {field?.dataLevel !== "System Default" && field.id ? (
                  <Button
                    style={{
                      minWidth: 36,
                      width: 36,
                      height: 36,
                      padding: 0,
                      background: "transparent",
                      border: "none",
                      position: "absolute",
                      top: 8,
                      right: 8,
                      zIndex: 2,
                    }}
                    onClick={() => handleActions("Delete", field?.id)}
                  >
                    <img
                      src={Delete}
                      alt="delete"
                      style={{ width: 16, height: 20 }}
                    />
                  </Button>
                ) : null}
              </Card>
            </Grid>
          ))}

          {isAllowedCreate && (
            <Box
              style={{
                width: 380,
                height: 70,
                borderRadius: 10,
                border: "2px dashed #36C96D",
                backgroundColor: "rgba(54, 201, 109,0.1)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: "20px",
                marginLeft: "20px",
                cursor: "pointer",
              }}
              elevation={0}
              onClick={handleAddField}
            >
              <CardContent
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid
                  xs={3}
                  style={{
                    width: 100,
                    height: 100,
                    marginLeft: 4,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Button
                    id="ProductLabel-button-0"
                    onClick={handleAddField}
                    style={{
                      background: `transparent linear-gradient(270deg, #1487CA 0%, #78BC27 100%) 0% 0% no-repeat`,
                      border: "none",
                      width: "50px",
                      height: "30px",
                      cursor: "pointer",
                      minWidth: "10px",
                      minHeight: "10px",
                      rowGap: "2px",
                      marginTop: "30px",
                    }}
                  >
                    <span style={{ color: "white", fontSize: "20px" }}>+</span>
                  </Button>
                  <Typography
                    variant="body1"
                    style={{
                      width: "250px",
                      marginRight: "0px",
                      marginLeft: "5px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("product.add_product_label")}
                  </Typography>
                </Grid>
              </CardContent>
            </Box>
          )}

          <Grid
            item
            container
            direction="row"
            spacing={1}
            rowSpacing={2}
            pl={2}
          >
            {newFields.map((field, index) => (
              <Grid key={index} item>
                <Card
                  id={`card-${index}`}
                  style={{
                    width: 380,
                    borderRadius: 6,
                    marginTop: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  elevation={0}
                >
                  <CardContent style={{ paddingBottom: 4, width: "100%" }}>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={8}>
                        <CustomInput
                          id="ProductLabel25"
                          value={field.label}
                          handleChange={(value) =>
                            handleFieldChange(index, field, value)
                          }
                          name="label"
                          size="small"
                          fullWidth
                          InputProps={field.id ? { readOnly: true } : {}}
                          resetError={() => console.log()}
                          style={{ boxSizing: "border-box" }}
                          placeholder={t("editor.product_label")}
                          height="40px"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Button
                          variant="contained"
                          style={{
                            minWidth: 0,
                            width: 36,
                            height: 36,
                            background: "linear-gradient(90deg, #1487CA 0%, #78BC27 100%)",
                            color: "#fff",
                            borderRadius: 4,
                            boxShadow: "none",

                          }}
                          onClick={handleSubmit}
                          title={t("common.save")}
                        >
                          <span style={{ fontSize: 20, fontWeight: "bold" }}>✔</span>
                        </Button>
                      </Grid>
                      <Grid item xs={2}>
                        <Button
                          style={{
                            minWidth: 0,
                            width: 36,
                            height: 36,
                            background: "transparent",
                            borderRadius: 2,
                            boxShadow: "none",
                            padding: 0,
                          }}
                          onClick={() => {
                            const updatedFields = newFields.filter((_, i) => i !== index);
                            setNewFields(updatedFields);
                          }}
                          title={t("common.delete")}
                        >
                          <img src={Delete} alt="delete" style={{ width: 20, height: 20 }} />
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid container xs={12} alignItems="left" style={{ marginTop: 12, display: "flex", }}>

                      <Grid item xs={12}>
                        <Radio
                          checked={field.type === "1"}
                          onChange={() => handleFieldChange(index, field, { target: { name: "type", value: "1" } })}
                          value="1"
                          name={`type-${index}`}
                          size="small"
                        />
                        <span style={{ fontSize: 15, verticalAlign: "middle" }}>{t("String") || "String"}</span>
                      </Grid>

                      <Grid item xs={12}>
                        <Radio
                          checked={field.type === "2"}
                          onChange={() => handleFieldChange(index, field, { target: { name: "type", value: "2" } })}
                          value="2"
                          name={`type-${index}`}
                          size="small"
                        />
                        <span style={{ fontSize: 15, verticalAlign: "middle" }}>{t("file") || "file"}</span>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
        {/* {newFields.length > 0 && check ? (
          <Grid item container pb={3} mr={5}>
            <Grid item xs={12}>
              <Grid
                display={"flex"}
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <Grid item pl={2} columnSpacing={2}>
                  <Button
                    id="ProductLabel-button-04"
                    className="text-transform-none"
                    variant="outlined"
                    onClick={handleCancel}
                    size="primary"
                    style={{
                      background: "#F7FBFE 0% 0% no-repeat padding-box",
                      marginRight: "10px",
                    }}
                  >
                    {t("common.cancel")}
                  </Button>
                  <Button
                    id="ProductLabel-button-03"
                    variant="contained"
                    size="primary"
                    className="text-transform-none"
                    style={{
                      background:
                        "transparent linear-gradient(270deg, #1487CA 0%, #78BC27 100%)",
                      color: "#FFFFFF",
                      fontSize: "normal normal normal 14px / 22px Roboto",
                      width: "80px",
                    }}
                    onClick={handleSubmit}
                  >
                    {t("common.save")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : null} */}

        <Dialog open={confirm} onClose={handleClose} maxWidth="md">
          <DialogTitle>
            <Typography variant="subtitle2">
              {t("tips.selected_delete_record")}
            </Typography>
          </DialogTitle>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            padding={"10px"}
            justifyContent={"center"}
          >
            <Box display="flex" justifyContent="center">
              <Button
                variant="outlined"
                color="primary"
                style={{ fontSize: "normal normal normal 14px / 22px Roboto" }}
                onClick={handleClose}
                sx={{ marginRight: 2 }}
              >
                {t("common.cancel")}
              </Button>

              <Button
                variant="contained"
                color="primary"
                style={{
                  background:
                    "transparent linear-gradient(270deg, #1487CA 0%, #78BC27 100%)",
                  color: "#FFFFFF",
                  fontSize: "normal normal normal 14px / 22px Roboto",
                  width: "80px",
                }}
                onClick={() => handleDelete(id)}
              >
                {t("common.delete")}
              </Button>
            </Box>
          </Grid>
        </Dialog>
      </Grid>
    </RightViewLayout>
  );
}
